import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  inject,
} from '@angular/core';

@Directive({
  selector: '[scoTooltip][dcOnlyIfTruncated]',
  standalone: true,
})
export class IsTruncatedDirective implements AfterViewInit, OnChanges {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  @Input() scoTooltip: string | null = null;
  @Input() dcOnlyIfTruncated = true;

  private isTruncated = false;
  private originalDisplay: string | null = null;

  ngAfterViewInit() {
    setTimeout(() => this.checkTruncation(), 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['scoTooltip'] || changes['dcOnlyIfTruncated']) {
      setTimeout(() => this.checkTruncation(), 0);
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.checkTruncation();
  }

  checkTruncation(): void {
    const element = this.el.nativeElement;

    this.isTruncated = element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;

    if (!this.dcOnlyIfTruncated || this.isTruncated) {
      this.renderer.setStyle(element, 'pointer-events', 'auto');
    } else {
      this.renderer.setStyle(element, 'pointer-events', 'none');
    }
  }
}
